// ======================================================================
// 📁 File: WorkerAssignmentCard.jsx
// PURPOSE:
//   Worker selection & assignment (Planning – Drawer)
//   - Supports primary + additional workers
//   - Workers restricted by routing skill
//   Planning only – no execution logic
// ======================================================================

import React, { useState } from "react";

export default function WorkerAssignmentCard({
  skill,
  workersBySkill = {},

  selectedWorkerId,      // primary (backward compatible)
  selectedWorkers = [],  // 🔧 [2026-01-15 22:05] – multi-worker support

  onPrimaryChange,
  onAddWorker,
  onRemoveWorker,
}) {
  const skillId = skill?.skill_id;
  const availableWorkers = skillId ? workersBySkill[skillId] || [] : [];

  const [additionalWorkerId, setAdditionalWorkerId] = useState("");

  return (
    <div className="card ppe-card mb-3">
      <div className="card-header">Manpower</div>

      <div className="card-body row g-3">
        {/* SKILL (READ-ONLY) */}
        <div className="col-md-6">
          <label className="form-label">Skill</label>
          <input
            className="form-control"
            value={skill?.skill_name || "—"}
            readOnly
          />
        </div>

        {/* PRIMARY WORKER */}
        <div className="col-md-6">
          <label className="form-label">Primary Worker</label>
          <select
            className="form-select"
            value={selectedWorkerId || ""}
            onChange={(e) => onPrimaryChange(e.target.value)}
            disabled={!skillId}
          >
            <option value="">
              {skillId ? "Select Worker" : "Skill not assigned"}
            </option>

            {availableWorkers.map((w) => (
              <option key={w.worker_id} value={w.worker_id}>
                {w.worker_name}
              </option>
            ))}
          </select>
        </div>

        {/* ADDITIONAL WORKERS */}
        {skillId && (
          <div className="col-12">
            <label className="form-label">Additional Workers</label>

            <div className="d-flex gap-2">
              <select
                className="form-select"
                value={additionalWorkerId}
                onChange={(e) => setAdditionalWorkerId(e.target.value)}
              >
                <option value="">Select Worker</option>
                {availableWorkers
                  .filter(
                    (w) =>
                      !selectedWorkers.includes(w.worker_id) &&
                      w.worker_id !== selectedWorkerId
                  )
                  .map((w) => (
                    <option key={w.worker_id} value={w.worker_id}>
                      {w.worker_name}
                    </option>
                  ))}
              </select>

              <button
                className="btn btn-outline-primary"
                disabled={!additionalWorkerId}
                onClick={() => {
                  onAddWorker(Number(additionalWorkerId));
                  setAdditionalWorkerId("");
                }}
              >
                Add
              </button>
            </div>

            {/* SELECTED ADDITIONAL WORKERS */}
            {selectedWorkers.filter((w) => w !== selectedWorkerId).length > 0 && (
              <ul className="list-group list-group-flush mt-2">
                {selectedWorkers
                  .filter((w) => w !== selectedWorkerId)
                  .map((workerId) => {
                    const worker = availableWorkers.find(
                      (aw) => aw.worker_id === workerId
                    );

                    return (
                      <li
                        key={workerId}
                        className="list-group-item d-flex justify-content-between align-items-center"
                      >
                        {worker?.worker_name || `Worker ${workerId}`}
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => onRemoveWorker(workerId)}
                        >
                          ✕
                        </button>
                      </li>
                    );
                  })}
              </ul>
            )}
          </div>
        )}

        {/* EMPTY STATE */}
        {skillId && availableWorkers.length === 0 && (
          <div className="col-12 text-muted small">
            No workers mapped to this skill
          </div>
        )}
      </div>
    </div>
  );
}
